import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PureMapComponent } from './components/pure-map/pure-map.component';
import { FullscreenOverlayDirective } from './directives/fullscreen-overlay/fullscreen-overlay.directive';
import { PureGoogleMapsServicesModule } from './pure-google-maps-services.module';

@NgModule({
  declarations: [PureMapComponent, FullscreenOverlayDirective],
  imports: [CommonModule, PureGoogleMapsServicesModule],
  exports: [PureMapComponent, FullscreenOverlayDirective]
})
export class PureGoogleMapsSharedModule {}
